export default "In some ways this is a limitation: you get different results each time you run the model, and can't precisely control the output.\n"